// extracted by mini-css-extract-plugin
module.exports = {"root":"media-gallery_root__v9YND","grid":"media-gallery_grid__r400x","item":"media-gallery_item__yUxql"};